import styled from 'styled-components';
import { color, bp } from '../../styles/tokens';

// Sits between the section head and the price cards: the technique explained
// once, next to the mark, so the cards can stay purely tabular.
export const Intro = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  max-width: 640px;
  margin: 0 auto clamp(32px, 5vw, 48px);
  padding: 22px 26px;
  background: ${color.roseSoft};
  border-radius: 14px;

  .mark {
    flex: none;
    color: ${color.fuchsia};
  }

  p {
    font-size: 14.5px;
    line-height: 1.55;
    color: ${color.text};

    ${bp.md} {
      font-size: 15px;
    }
  }
`;
